// Kundenakte (28.10.2026): kleine Helfer für Kopf und Übersicht — nur Anzeige, gerechnet wird im Server (kundenakte.py).

export const datumKurz = (iso) => {
  if (!iso) return '–';
  const [j, m, t] = String(iso).slice(0, 10).split('-');
  return t && m ? `${t}.${m}.${j ? j.slice(2) : ''}` : String(iso);
};

export const komma = (wert, stellen = 1) =>
  wert === null || wert === undefined ? '–' : Number(wert).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: stellen });

// Vorzeichen mit echtem Minus; `gutWennWeniger` färbt die Richtung (Gewicht/Körperfett runter = gut, Muskel rauf = gut)
export const delta = (wert, einheit = '', gutWennWeniger = true) => {
  if (wert === null || wert === undefined) return null;
  const text = `${wert > 0 ? '+' : wert < 0 ? '−' : '±'}${komma(Math.abs(wert))}${einheit ? ` ${einheit}` : ''}`;
  const gut = wert === 0 ? null : gutWennWeniger ? wert < 0 : wert > 0;
  return { text, klasse: gut === null ? 'text-muted-foreground' : gut ? 'text-emerald-600 dark:text-emerald-400' : 'text-amber-600 dark:text-amber-400' };
};

export const STATUS_KLASSE = {
  mitglied: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/30',
  pausiert: 'bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30',
  gekuendigt: 'bg-muted text-muted-foreground border-border',
  lead: 'bg-marke/10 text-marke border-marke/30',
};

export const ERGEBNIS_TEXT = {
  buchen: 'gebucht', senden: 'Angebot gesendet', gebucht: 'gebucht', angebot_gesendet: 'Angebot gesendet', spaeter: 'später', kein_bedarf: 'kein Bedarf',
  abgelehnt: 'abgelehnt', offen: 'offen',
};

export const TERMIN_ART = { kurs: 'Kurs', probetraining: 'Probetraining', pt: 'PT', checkup: 'Check-up' };
